import { render, staticRenderFns } from "./LightboxInfo.vue?vue&type=template&id=31ecfebe&scoped=true"
import script from "./LightboxInfo.vue?vue&type=script&lang=ts"
export * from "./LightboxInfo.vue?vue&type=script&lang=ts"
import style0 from "./LightboxInfo.vue?vue&type=style&index=0&id=31ecfebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ecfebe",
  null
  
)

export default component.exports